import React from "react";
import { LuRuler } from "react-icons/lu";

import { sanitizeRate } from "../../static/processRate";
import Input from "./Input";
import cx from "./cx";
import { fieldInputClass, formFieldIconClass } from "./styles";

type Props = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "value" | "onChange"
> & {
  value: string;
  onChange: (value: string) => void;
  // Shown after the number, such as "mm" (the size unit setting).
  unit?: string;
  hasError?: boolean;
};

// A length box, like RateInput: the length stays as typed text, kept to digits with up to 2 decimals.
const LengthInput = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, unit, hasError, className, ...props }, ref) => (
    <div className="relative">
      <LuRuler className={formFieldIconClass} />
      <Input
        ref={ref}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        maxLength={11}
        value={value ?? ""}
        className={cx(
          fieldInputClass(hasError),
          "bg-white",
          unit && "pr-12",
          className
        )}
        onChange={(e) => onChange(sanitizeRate(e.target.value))}
        {...props}
      />
      {unit && (
        <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-sm font-medium text-gray-500">
          {unit}
        </span>
      )}
    </div>
  )
);

LengthInput.displayName = "LengthInput";

export default LengthInput;
